<template>
	<div>
		<div class="tree_echarts" id="tree_echarts"></div>
	</div>
</template>
<script>
export default {
	name: '',
	components: {},
	mixins: [],
	props: ['echartsData'],
	data() {
		return {};
	},
	computed: {},
	watch: {
		echartsData: {
			handler(val) {
				// console.log(val);
				this.getEcharts(val);
			},
			// immediate: true,不能加深度监听  数据为空的时候也加载了
		},
	},
	mounted() {},
	methods: {
		getEcharts(echartsData) {
			var chartDom = document.getElementById('tree_echarts');
			var myChart = this.$echarts5.init(chartDom);
			let _this = this;
			let option = {
				tooltip: {
					trigger: 'item',
					triggerOn: 'mousemove',
					confine: true,

					formatter(item) {
						console.log(item);

						if (item.value) {
							//如果有value代表这个是第三级节点
							if (item.value.indexOf('||') > 0) {
								//如果有||说明要换行
								let values = item.value.split('||');
								let processedValues = values.map(
									_this.addLineBreaks
								);
								return processedValues.join('<br/><br/>');
								// let values = item.value.split('||');
								// console.log(values);
								// let retrunStr = values.join('<br/><br/>');

								// return _this.addLineBreaks(retrunStr);
							}
							return _this.addLineBreaks(item.value);
						} else {
							return item.value;
						}
					},
				},
				series: [
					{
						type: 'tree',
						id: 0,
						name: 'tree1',
						data: [echartsData],
						top: '3%',
						left: '17%',
						bottom: '3%',
						right: '28%',
						symbolSize: 7,
						initialTreeDepth: -1,
						edgeShape: 'polyline',
						edgeForkPosition: '63%',
						lineStyle: {
							width: 1,
						},
						label: {
							// backgroundColor: '#fff',
							position: 'right',
							verticalAlign: 'middle',
							align: 'center',
							// distance: 100,
							formatter(item) {
								if (item.dataIndex == 1) {
									return '{a|《中共中央国务院\n关于完整准确全面贯彻\n新发展理念做好碳达峰碳中和工作的意见》}';
									// + item.name
									// _this.addLineBreaksLabel(item.name) +
								}
							},
							rich: {
								a: {
									// position: 'left',
									// color: 'red',
									// align: 'center',
									// lineHeight: 10,
								},
							},
						},
						itemStyle: {
							normal: {
								color: {
									type: 'radial',
									x: 0.5,
									y: 0.5,
									r: 0.5,
									colorStops: [
										{
											offset: 0,
											color: '#35a345', // 0% 处的颜色
										},
										{
											offset: 1,
											color: '#c3e38a', // 100% 处的颜色
										},
									],
									globalCoord: false, // 缺省为 false
								},
							},
						},

						leaves: {
							label: {
								position: 'right',
								verticalAlign: 'middle',
								align: 'left',
							},
						},
						emphasis: {
							focus: 'descendant',
						},
						expandAndCollapse: true,
						animationDuration: 550,
						animationDurationUpdate: 750,
					},
				],
			};
			myChart.clear();
			myChart.setOption(option);
			myChart.on('click', function(param) {
				//console.log(param);
			});
		},
		addLineBreaks(value) {
			const maxLength = 50;
			let result = '';
			while (value.length > maxLength) {
				result += value.substring(0, maxLength) + '<br/>';
				value = value.substring(maxLength);
			}

			result += value;
			return result;
		},
		addLineBreaksLabel(value) {
			const maxLength = 8;
			let result = '';
			while (value.length > maxLength) {
				result += value.substring(0, maxLength) + '\n';
				value = value.substring(maxLength);
			}
			result += value;
			return result;
		},
	},
};
</script>
<style lang="less" scoped>
.tree_echarts {
	width: 100%;
	height: 700px;
}
</style>



// WEBPACK FOOTER //
// src/view/actionPlan/components/tree/index.vue